import { render, staticRenderFns } from "./Errand.vue?vue&type=template&id=82236590&scoped=true&"
import script from "./Errand.vue?vue&type=script&lang=js&"
export * from "./Errand.vue?vue&type=script&lang=js&"
import style0 from "./Errand.vue?vue&type=style&index=0&id=82236590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82236590",
  null
  
)

export default component.exports